
const renderConsoleWarning = () => {
    console.log("%cStop!", "font-size: 50px; color:red");
    console.log(
        "%cThis is a browser feature intended for developers. If someone told you to copy-paste something here to enable a Scispot feature or “hack” someone’s account, it is a scam and will give them access to your Scispot account. Learn more: https://en.wikipedia.org/wiki/Self-XSS",
        "font-size: 20px;"
    );
};

export {renderConsoleWarning}